<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <!-- <div id="navi-btn" class="navi-btn"
        @click="state.visibleSearchExtract = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div> -->

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>お知らせ</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="info-detail-label">
              <span v-if="data.classification === 3 || data.classification === 2"
                class="icon-label" :class="data.classification === 3 ? 'red' : 'gray'"
                >{{ data.classification_name }}</span>
            </div>
            <div class="info-detail-heading">
              <span class="info-detail-date">{{data.publication_day}}</span>
              <span class="info-detail-category">{{data.category_name}}</span>
            </div>
          </div>
          <div class="main-container"
            @scroll="handleScroll"
            >
            <h2 class="info-detail-title">{{data.title}}</h2>
            <p class="info-detail-text" v-html="data.detail"></p>
          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import { InformationDetail } from '@/logic/information/InformationDetail'

import SPMenu from '@/components/sp/popup/SPMenu.vue'

export default defineComponent({
  components: {
    SPMenu
  },
  props: {
    infoId: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {
    return { ...InformationDetail(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  padding-right: 82px;
  &-select {
    padding-left: 10px;
    .formparts.select {
      .select-label {
        color: #fff;
        font-size: 1.2rem;
        height: 36px;
        width: 136px;
        border-color: rgba(255,255,255,.2);
        .icn {
          color: #fff;
        }
      }
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
  }
}

.main {
  &-container {
    background-color: $color-bg-paper;
    @include changeHeightOnScroll(126px);
    .date {
      font-size: 1.4rem;
      color: $color-content;
      padding: 32px 20px;
    }
    .list-result {
      background-color: #fff;
    }
  }
  &-heading {
    position: relative;
    .navi-list {
      margin: 0 40px;
      overflow-x: auto;
      white-space: nowrap;
      &-item {
        display: inline-block;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 100%;
          background-color: $color-yellow;
          opacity: 0;
          transition: all .2s ease;
        }
        &-label {
          display: block;
          font-size: 1.6rem;
          color: $color-sup;
          font-weight: bold;
          padding: 20px 10px;
        }
        &.is-active {
          &:after {
            opacity: 1;
          }
          .navi-list-item-label {
            color: $color-link;
          }
        }
      }
    }
    .navi-arrow {
      position: absolute;
      top: 50%;
      transform: translate3d(0,-55%,0);
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      .icn {
        color: $color-link;
      }
      &.next {
        right: 0;
        border-left: 1px solid $color-line;
      }
      &.prev {
        left: 0;
        border-right: 1px solid $color-line;
      }
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}
.main-heading{
  border-bottom: 1px solid #ddd;
}
.info-detail-label{
  padding: 20px 20px 0;
}
.info-detail-heading{
  margin: 10px 20px 20px;
  font-size: 14px;
  color: #999999;
}
.info-detail-date{
  margin-right: 20px;
}
.info-detail-category{
}
.info-detail-title{
  margin: 20px 20px 0;
  line-height: 1.75;
  font-size: 20px;
  fnt-weight: bold;
  color: #3B4557
}
.info-detail-text{
  margin: 10px 20px 0;
  line-height: 1.75;
  font-size: 16px;
  color: #555;
  & + .info-detail-title{
    margin: 100px 20px 0;
  }
}

</style>
